import React from 'react';
export function CreditCardIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.132 4.892a2.982 2.982 0 00-2.12-.88l-14-.022a3 3 0 00-3 3l-.014 10a3 3 0 003 3l14 .021a3 3 0 003-3l.014-10a2.976 2.976 0 00-.88-2.119zM5.007 5.99l14 .021a1 1 0 011 1v2L4 8.988v-2a1 1 0 011.007-.998zm13.986 12.021l-14-.02a1 1 0 01-1-1l.008-6 16 .023-.008 6a1 1 0 01-1 .997z"
  }));
}